import React, { useState } from "react";
import { sf_mucphaithu } from "../../../models/response/thu-phi/sf_mucphaithu";
import { bienLaiThuApi } from "../../../api/bienLaiApi";
import { mucPhaiThuApi } from "../../../api/mucPhaiThuApi";
import { showNotify } from "../../../helpers/toast";
import { formatVND } from "../../../utils/formatVND";
import SendEmailModalBase from "./SendEmailModalBase";
import SendThongBaoPhiPrintBtn from "./SendThongBaoPhiPrintBtn";
import { QRModalContent } from "../tao-bien-lai";
import Modal from "../../../components/ui/modal";
import { Button } from "../../buttons";
import { PlaceHolder } from "../../place-holder";
import ModalActions from "../../../components/ui/modal/ModalActions";
import UiButton from "../../../components/ui/button";
import { XIcon, KeyIcon, DownloadIcon } from "@primer/octicons-react";
import styles from "../tao-bien-lai/TaoBienLai.module.css";

type SendThongBaoPhiModalProps = {
    onClose: () => void,
    sf_mucphaithu: sf_mucphaithu,
    ts_hocsinh_id: number,
    printDisabled?: boolean,
    buttonText?: string
}

const SendThongBaoPhiModal: React.FC<SendThongBaoPhiModalProps> = (props) => {
    const [isShowQrModal, setIsShowQrModal] = useState<boolean>(false);
    const [isShowBidvQrModal, setIsShowBidvQrModal] = useState<boolean>(false);
    const [bidvQrLoading, setBidvQrLoading] = useState<boolean>(false);
    const [bidvQrImage, setBidvQrImage] = useState<string>("");
    const [bidvQrData, setBidvQrData] = useState<any>(null);

    const handleGenBidvQr = async () => {
        setBidvQrLoading(true);
        setBidvQrImage("");
        setBidvQrData(null);
        try {
            const res: any = await mucPhaiThuApi.gen_qr({ sf_mucphaithu_id: props.sf_mucphaithu.id });
            if (res.is_success && res.data) {
                setBidvQrImage(res.data.qrImage || "");
                setBidvQrData(res.data);
            } else {
                showNotify({ message: res.message || "Không thể tạo mã QR từ BIDV", type: "warning" });
            }
        } catch (error) {
            showNotify({ message: "Lỗi kết nối API BIDV", type: "error" });
        } finally {
            setBidvQrLoading(false);
        }
    };

    const handleDownloadBidvQr = () => {
        if (!bidvQrImage) return;
        const link = document.createElement("a");
        link.href = bidvQrImage.startsWith("data:") ? bidvQrImage : `data:image/png;base64,${bidvQrImage}`;
        link.download = `BIDV_QR_${props.sf_mucphaithu.so_chung_tu || "export"}.png`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    return (
        <>
            <SendEmailModalBase
                onClose={props.onClose}
                sf_mucphaithu={props.sf_mucphaithu}
                ts_hocsinh_id={props.ts_hocsinh_id}
                buttonText={props.buttonText}
                title="Gửi thông báo phí đến PHHS"
                sendButtonText="Gửi thông báo phí"
                successMessage="Đã gửi email thông báo phí"
                failedMessage="Không gửi được thông báo phí"
                loadEmailContent={bienLaiThuApi.get_thongbaophi_email_content}
                sendEmail={bienLaiThuApi.send_thongbaophi}
                renderPrintButton={() => (
                    <>
                        {!props.sf_mucphaithu.so_chung_tu.includes("RV") && (
                            <SendThongBaoPhiPrintBtn
                                disabled={props.printDisabled ?? false}
                                sf_mucphaithu={props.sf_mucphaithu}
                                buttonText="In thông báo phí"
                            />
                        )}
                        {/* <Button
                            type="normal"
                            text="Mã QR Thanh toán"
                            icon="fa fa-qrcode"
                            isDisabled={false}
                            onClick={() => setIsShowQrModal(true)}
                        /> */}
                        <Button
                            type="normal"
                            text="QR BIDV"
                            icon="fa fa-qrcode"
                            isDisabled={props.sf_mucphaithu.tong_tien_da_nop > 0}
                            onClick={() => { setIsShowBidvQrModal(true); handleGenBidvQr(); }}
                        />
                    </>
                )}
            />

            {isShowQrModal && (
                <Modal
                    title="Mã QR Thanh toán BIDV"
                    width="60%"
                    isOpen={isShowQrModal}
                    onClose={() => setIsShowQrModal(false)}
                >
                    <QRModalContent
                        sf_mucphaithu={props.sf_mucphaithu}
                        onClose={() => setIsShowQrModal(false)}
                    />
                </Modal>
            )}

            {isShowBidvQrModal && (
                <Modal
                    title="Mã QR BIDV (API đối tác)"
                    width="60%"
                    isOpen={isShowBidvQrModal}
                    onClose={() => setIsShowBidvQrModal(false)}
                >
                    <div className={styles.qrContainer}>
                        <div className={styles.qrTitle}>Mã QR từ BIDV API</div>
                        <div className={styles.qrSubtitle}>Mã QR được tạo trực tiếp từ hệ thống BIDV</div>
                        {bidvQrLoading ? (
                            <div style={{ padding: "40px 0", textAlign: "center", width: "100%" }}>
                                <PlaceHolder line_number={5} />
                                <div style={{ marginTop: "12px", color: "#586069" }}>Đang gọi API BIDV tạo mã QR...</div>
                            </div>
                        ) : bidvQrImage ? (
                            <>
                                <div className={styles.qrImageSection}>
                                    <img
                                        src={bidvQrImage.startsWith("data:") ? bidvQrImage : `data:image/png;base64,${bidvQrImage}`}
                                        alt="BIDV QR"
                                        className={styles.qrImage}
                                    />
                                    <button className={styles.downloadButton} onClick={handleDownloadBidvQr}>
                                        <DownloadIcon /> Tải ảnh QR
                                    </button>
                                </div>
                                {bidvQrData && (
                                    <div className={styles.qrDetailsSection}>
                                        <div className={styles.detailRow}>
                                            <span className={styles.detailLabel}>Số tài khoản</span>
                                            <span className={styles.detailValue} style={{ fontWeight: "bold" }}>2892899998 (Ngân hàng BIDV)</span>
                                        </div>
                                        <div className={styles.detailRow}>
                                            <span className={styles.detailLabel}>Mã khách hàng</span>
                                            <span className={styles.detailValue}>{bidvQrData.code || ""}</span>
                                        </div>
                                        <div className={styles.detailRow}>
                                            <span className={styles.detailLabel}>Tên</span>
                                            <span className={styles.detailValue}>{bidvQrData.name || ""}</span>
                                        </div>
                                        <div className={styles.detailRow}>
                                            <span className={styles.detailLabel}>Số tiền</span>
                                            <span className={styles.detailValue} style={{ fontWeight: "bold", color: "#cf222e" }}>
                                                {formatVND(Number(bidvQrData.amount) || 0)} đ
                                            </span>
                                        </div>
                                        <div className={styles.detailRow} style={{ borderBottom: "none" }}>
                                            <span className={styles.detailLabel}>Nội dung</span>
                                            <span className={styles.detailValue}>{bidvQrData.description || ""}</span>
                                        </div>
                                    </div>
                                )}
                            </>
                        ) : (
                            <div style={{ color: "#d73a49", padding: "20px 0", textAlign: "center" }}>Không thể tạo mã QR từ BIDV.</div>
                        )}
                        <ModalActions>
                            <UiButton variant="default" leadingVisual={XIcon} text="Đóng" onClick={() => setIsShowBidvQrModal(false)} />
                            <UiButton variant="default" leadingVisual={KeyIcon} text="Tạo lại QR" onClick={handleGenBidvQr} isLoading={bidvQrLoading} />
                        </ModalActions>
                    </div>
                </Modal>
            )}
        </>
    );
};

export default SendThongBaoPhiModal;
